<script lang="ts" setup>
import constants from '~/constants'
import helpers from '~/helpers'
import formatter from '~/helpers/formatter'
import type { ReviewData } from '~/types/reviews'

const props = defineProps<{
  reviewData: ReviewData
}>()

const advantages = computed(() => attributes.value.advantages)
const attributes = computed(() => props.reviewData.attributes)
const authorName = computed(() => props.reviewData.meta.authorName)
const comment = computed(() => attributes.value.comment)
const disadvantages = computed(() => attributes.value.disadvantages)
const formattedCreationDateInMsk = computed(() => getFormattedDateInMsk(attributes.value.createdAt))
const formattedReplyCreationDateInMsk = computed(() => getFormattedDateInMsk(replyCreatedAt.value))
const isAnonymous = computed(() => attributes.value.isAnonymous)
const reply = computed(() => attributes.value.reply)
const replyCreatedAt = computed(() => attributes.value.replyCreatedAt)
const scoreAsNumber = computed(() => attributes.value.score)
const textBlocks = computed(() => [
  { title: 'Достоинства', content: advantages.value },
  { title: 'Недостатки', content: disadvantages.value },
  { title: 'Комментарий', content: comment.value }
])

function getFormattedDateInMsk (dateTime: string): string {
  return formatter.formatDateTime(dateTime, constants.dateTimeFormats.dateFull)
}
</script>

<template>
  <div class="rounded-2xl bg-main-very-light-gray p-4 lg:p-5">
    <div v-if="advantages || disadvantages || comment" class="mb-2">
      <template v-for="x in textBlocks">
        <div
          v-if="x.content"
          :key="x.title"
          class="mb-2 text-sm leading-[1.43] tracking-[-0.01em] text-main-dark md:text-base md:leading-normal"
        >
          <div class="mb-1 text-sm text-main-green">
            {{ x.title }}
          </div>

          <pre class="pre-wrap">{{ x.content }}</pre>
        </div>
      </template>
    </div>

    <div class="flex flex-wrap items-center">
      <Score :score="scoreAsNumber" />

      <div
        class="
          ml-1 flex items-center text-xs leading-[1.33] text-main-dark opacity-40 md:ml-4 md:text-sm md:leading-[1.71]
        "
      >
        <div v-if="reviewData.attributes.createdAt">
          {{ formattedCreationDateInMsk }}
        </div>

        <span class="block px-1 md:px-2">·</span>

        <div>{{ helpers.getReviewAuthorName(authorName, isAnonymous) }}</div>
      </div>
    </div>

    <div v-if="reply" class="mt-2 rounded-xl bg-white p-4 md:mt-5 md:p-5">
      <div class="mb-1 text-xs leading-[1.33] text-main-green md:text-sm md:leading-[1.71]">
        Ответ продавца
      </div>

      <pre
        class="pre-wrap text-sm leading-[1.43] tracking-[-0.01em] text-main-dark md:text-base md:leading-normal"
      >{{ reply }}</pre>
    </div>
  </div>
</template>
